import { render, staticRenderFns } from "./VideoCamIcon.vue?vue&type=template&id=52324a35&scoped=true&"
import script from "./VideoCamIcon.vue?vue&type=script&lang=js&"
export * from "./VideoCamIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52324a35",
  null
  
)

export default component.exports